let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgWS7")).then(() => parcelRequire('3tsG4'));